'use strict';

require('../css/default.css');
var ReactTelephoneInput = require('./ReactTelephoneInput');

module.exports = ReactTelephoneInput;


// WEBPACK FOOTER //
// ./node_modules/react-telephone-input/lib/withStyles.js